<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card v-on:keyup.enter="buildNewSearch">
		<v-card-title>
			<h2>Wolontariusze</h2>
			<v-spacer></v-spacer>
		</v-card-title>

		<v-layout align-center justify-center row>
			<v-flex xs2>
				<v-text-field
					class="ma-2"
					browser-autocomplete="off"
					v-model="dataTable.searchFields.surname"
					label="Nazwisko"
					aria-label="surname"
					for="volunteers-view-surname"
					id="volunteers-view-surname"
				></v-text-field>
			</v-flex>
			<v-flex xs2>
				<v-autocomplete
					class="ma-2"
					v-model="dataTable.searchFields.languageId"
					:items="languageList"
					item-text="name"
					item-value="id"
					label="Język obcy"
					aria-label="foreign language"
					for="volunteers-view-language"
					id="volunteers-view-language"
					clearable
				></v-autocomplete>
			</v-flex>
			<v-flex xs2>
				<v-autocomplete
					class="ma-2"
					v-model="dataTable.searchFields.countryId"
					:items="countryList"
					item-text="name"
					item-value="id"
					aria-label="volunteering country"
					label="Kraj odbywania wolontariatu"
					for="volunteers-view-country-volunteer"
					id="volunteers-view-country-volunteer"
					clearable
				></v-autocomplete>
			</v-flex>
			<v-flex xs4>
				<v-layout align-center justify-center>
					<v-btn @click="getItemList" color="primary" dark class="mb-2">Szukaj</v-btn>
					<v-btn @click="resetSearch" color="primary" dark class="mb-2">Resetuj</v-btn>
					<v-btn v-if="!roles.isBidder()" @click="exportData" color="primary" dark class="mb-2">Eksportuj
					</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>

		<v-data-table
			:headers="dataTable.tableHeaders"
			:rows-per-page-items="[10,20,25]"
			:loading="dataTable.loading"
			:items="dataTable.itemList"
			:total-items="dataTable.itemCount"
			:pagination.sync="dataTable.pagination"
			class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr :class="props.item.accountRemovalRequested && roles.isAdministrator() ? 'removalRequest' : ''"
					:key="props.item.email">
					<td style="width: 70px;" v-if="dataTable.itemList.some(item => item.accountRemovalRequested)">
						<template v-if="props.item.accountRemovalRequested && roles.isAdministrator()">
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-icon color="primary" dark v-on="on">info</v-icon>
								</template>
								<span>Wolontariusz zgłosił prośbę o usunięcie konta</span>
							</v-tooltip>
						</template>
					</td>
					<td>{{ props.item.name }}</td>
					<td>{{ props.item.surname }}</td>
					<td>{{ props.item.languages.join(", ") }}</td>
					<td>{{ props.item.preferredVolunteeringCountries.join(", ") }}</td>
					<td>{{ props.item.email }}</td>
					<td v-if="roles.isAdministrator() && props.item.accountRemovalRequested">
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon
									@click="deleteVolunteer(props.item)">
									<v-icon color="lightred" v-on="on">
										delete
									</v-icon>
								</v-btn>
							</template>
							<span>Usuń</span>
						</v-tooltip>
					</td>
				</tr>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Api} from "@/api";
	import {VolunteerLanguage} from "@/api/generated/VolunteerLanguage";
	import {AccreditationCountry} from "@/api/generated/AccreditationCountry";
	import {ExportUtils} from "@/utils/ExportUtils";
	import {User} from "@/api/generated/User";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "VolunteersView",

    mixins: [Filters],

		watch: {
			"dataTable.pagination": {
				handler(pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			}
		},

		computed: {
			pages () {
				// paginacja nie została zainicjalizowana
				if (this.dataTable.pagination.rowsPerPage === undefined) {
					return 0;
				}
				return Math.ceil(this.dataTable.itemCount / this.dataTable.pagination.rowsPerPage);
			},
		},

		methods: {
			exportData () {
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				let sort = this.buildSort();
				let path = "/volunteer/export?search=" + this.dataTable.search
					+ "&sort=".concat(sort);
				ExportUtils.sendExportRequest(path, this);
			},

			getItemList () {
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				let sort = this.buildSort();
				Api.get(this,
					"/volunteer/list?search=" + this.dataTable.search
						+ "&page=" + this.dataTable.pagination.page
						+ "&result=" + this.dataTable.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.dataTable.itemList = response.itemList;
							this.dataTable.itemCount = response.itemCount;
							this.organizeColumns();
						});
			},

			resetSearch () {
				this.clearFields();
				this.getItemList();
			},

			clearFields () {
				this.dataTable.searchFields.surname = '';
				this.dataTable.searchFields.languageId = undefined;
				this.dataTable.searchFields.countryId = undefined;
			},

			refresh () {
				this.getItemList();
				getLanguageList(this);
				getCountryList(this);
			},

			buildSearch (searchFields) {
				let search = '';
				if (searchFields.surname !== '') {
					search = search.concat("surname::" + searchFields.surname + "$$");
				}
				if (searchFields.languageId !== undefined) {
					search = search.concat("languageId::" + searchFields.languageId + "$$");
				}
				if (searchFields.countryId !== undefined) {
					search = search.concat("countryId::" + searchFields.countryId + "$$");
				}
				return search;
			},

			buildSort() {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			deleteVolunteer (item) {
				if (!this.roles.isAdministrator()) return;
				this.$confirm("Czy na pewno chcesz usunąć wolontariusza " + item.name + " " + item.surname + "?", {
					icon: "warning",
					title: "Usunięcie wolontariusza",
					color: "red",
					width: 500,
				})
					.then(response => {
						if (response) {
							User.delete(this, item.id, successResponse => {
									this.refresh();
									this.$messagesBus.$emit("success", "Wolontariusz został pomyślnie usunięty", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć wolontariusza", errorResponse);
								});
						}
					});
			},

			organizeColumns () {
				this.dataTable.tableHeaders = [
					{text: "Imię", value: "name", sortable: true},
					{text: "Nazwisko", value: "surname", sortable: true},
					{text: "Języki obce", value: "languages", sortable: false},
					{
						text: "Kraje wolontariatu",
						value: "preferredVolunteeringCountries",
						sortable: false
					},
					{text: "E-mail", value: "email", sortable: true}
				];
				if (this.roles.isAdministrator()) {
					this.addAdministratorColumns();
				}
			},

			addAdministratorColumns () {
				if (!this.dataTable.itemList.some(item => item.accountRemovalRequested)) {
					return;
				}
				this.dataTable.tableHeaders.unshift(
					{text: "", value: "accountRemovalRequested", sortable: false}
				);
				this.dataTable.tableHeaders.push(
					{text: "Akcje", value: "action", sortable: false}
				);
			}
		},

		mounted () {
			getLanguageList(this);
			getCountryList(this);
      this.dataTable.searchFields = this.retrieveFilters(this.dataTable.searchFields);
      this.dataTable.pagination = this.retrievePagination(this.dataTable.pagination);
		},

		data () {
			return {
				dataTable: {
					searchFields: {
						surname: '',
						languageId: undefined,
						countryId: undefined,
					},
					tableHeaders: [
						{text: "Imię", value: "name", sortable: true},
						{text: "Nazwisko", value: "surname", sortable: true},
						{text: "Języki obce", value: "languages", sortable: false},
						{
							text: "Kraje wolontariatu",
							value: "preferredVolunteeringCountries",
							sortable: false
						},
						{text: "E-mail", value: "email", sortable: true}
					],
					loading: false,
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
					},
					search: "",
				},

				languageList: [],

				countryList: []
			};
		},
	};

	function getLanguageList (ctx) {
		VolunteerLanguage.getRegistrationLanguages(ctx, successResponse => {
			ctx.languageList = successResponse;
		}, errorResponse => {
			ctx.$messagesBus.$emit("error", "Nie udało się załadować listy języków", errorResponse);
		});
	}

	function getCountryList (ctx) {
		AccreditationCountry.get(ctx, successResponse => {
				ctx.countryList = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować krajów wolontariatu", errorResponse);
			});
	}

</script>

<style scoped>
	.removalRequest {
		background-color: rgb(232, 232, 232);
	}

	.theme--dark .removalRequest {
		background-color: #606060 !important;
	}
</style>
